// ======================================================================
// File Name       : top
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';

export function doNotificeForSystemList(data) {
  return commonCallApi({
    path: 'noticeForSystem/GetList',
    data,
  });
}
